/* eslint-disable jsx-a11y/label-has-associated-control */
import TableWrapper from 'components/common/table-wrapper/TableWrapper'
import { alertTypes, initialMetaForTable } from 'constants/Common'
import React, { useEffect, useMemo, useState } from 'react'
// import { useNavigate } from 'react-router-dom'
import moment from 'moment'
import AddIcon from 'assets/images/shell/icon-add.svg'
import MoreIcon from 'assets/images/shell/icon-more.svg'
import SortIcon from 'assets/images/shell/icon-sort.svg'

import { toast } from 'react-toastify'
import CustomToast from 'components/common/custom-toast/CustomToast'
import {
  createNotification,
  deleteNotification,
  getNotifications,
  updateNotification,
} from 'containers/notifications/Api'
import ConfirmationModal from './ConfirmationModal'
import NotificationModal from './NotificationModal'

let timeout
const DEBOUNCE_DELAY = 700
function NotificationsListing() {
  //   const navigate = useNavigate()
  const [notificationsList, setNotificationsList] = React.useState([])
  const [loading, setLoading] = React.useState(true)
  const [meta, setMeta] = React.useState({
    ...initialMetaForTable,
    perPage: 10,
  })
  const [openActionId, setOpenActionId] = useState(null)
  const [statusSort, setStatusSort] = useState(null)
  const [isNotificationModalVisible, setNotificationModalVisible] =
    React.useState(false)
  const [refresh, setRefresh] = React.useState(false)
  const [selectedNotification, setSelectedNotification] = useState()
  const [
    isNotificationConfirmationModalVisible,
    setNotificationConfirmationModalVisible,
  ] = useState(false)
  const [isDeleting, setIsDeleting] = useState(false)

  const handleRefresh = () => {
    setRefresh((pre) => !pre)
  }
  const handleSetPerPage = (obj) => {
    setMeta((pre) => ({ ...pre, perPage: obj.value, page: 1 }))
    handleRefresh()
  }
  const debounceFn = (callback, delay) => {
    clearTimeout(timeout)
    timeout = setTimeout(callback, delay)
  }
  const handleSetSearchQuery = (value) => {
    setMeta((pre) => ({ ...pre, search: value }))
    debounceFn(handleRefresh, DEBOUNCE_DELAY)
  }
  const handlePageChange = (value) => {
    setMeta((pre) => ({ ...pre, page: value }))
    handleRefresh()
  }
  const handleCloseModal = () => {
    setNotificationModalVisible(false)
    setSelectedNotification()
  }
  const handleOpenModal = () => {
    setNotificationModalVisible(true)
  }
  const fetchNotifications = async () => {
    const result = await getNotifications(meta.page, meta.perPage, meta.search)
    if (result?.LastPage && result?.Total) {
      const resultMeta = result
      setMeta((pre) => ({
        ...pre,
        totalCount: resultMeta.Total,
        totalPages: resultMeta.LastPage,
      }))
    }
    if (result?.data) {
      const { data } = result
      const start = (meta.page - 1) * meta.perPage
      const pageRows =
        data.length > meta.perPage
          ? data.slice(start, start + meta.perPage)
          : data
      setNotificationsList(pageRows)
    }
    setLoading(false)
  }

  const handleCreateNotification = async (values) => {
    const updatedValues = { ...values, status: 'pending' }
    const result = await createNotification(updatedValues)
    if (result?.status === 200) {
      toast(
        <CustomToast
          variant={alertTypes.SUCCESS}
          message={result?.statusText || 'Notification Created Successfully!'}
        />
      )
      handleRefresh()
      handleCloseModal()
    } else {
      toast(
        <CustomToast
          variant={alertTypes.DANGER}
          message={result?.response?.data?.error}
        />
      )
    }
  }

  const handleUpdateNotification = async (payload) => {
    /* eslint no-underscore-dangle: 0 */
    const id = payload._id
    const updatedValues = { ...payload, status: 'pending' }
    const result = await updateNotification(updatedValues, id)
    if (result?.status === 200) {
      toast(
        <CustomToast
          variant={alertTypes.SUCCESS}
          message={result?.statusText || 'Noification Updated Successfully!'}
        />
      )
      handleCloseModal()
      handleRefresh()
    } else {
      toast(
        <CustomToast
          variant={alertTypes.DANGER}
          message={result?.response?.data?.error}
        />
      )
    }
  }

  const handleCloseNotificationConfirmationModal = () => {
    setNotificationConfirmationModalVisible(false)
    setSelectedNotification()
    setIsDeleting(false)
  }
  const handleOpenNotificationConfirmationModal = () => {
    setNotificationConfirmationModalVisible(true)
  }
  const handleDeleteNotification = async () => {
    // eslint-disable-next-line no-underscore-dangle
    const result = await deleteNotification(selectedNotification._id)
    if (result?.status === 200) {
      toast(
        <CustomToast
          variant={alertTypes.SUCCESS}
          message={result?.statusText || 'Notification Deleted Successfully!'}
        />
      )
      handleRefresh()
      handleCloseNotificationConfirmationModal()
    } else {
      toast(
        <CustomToast
          variant={alertTypes.DANGER}
          message={result?.response?.data?.error}
        />
      )
    }
  }
  const handleConfirmNotification = () => {}

  const visibleNotifications = useMemo(() => {
    if (!statusSort) return notificationsList
    return [...notificationsList].sort((left, right) => {
      const result = String(left.status || '').localeCompare(
        String(right.status || '')
      )
      return statusSort === 'asc' ? result : -result
    })
  }, [notificationsList, statusSort])

  const statusLabel = (status) => {
    const value = String(status || 'pending').toLowerCase()
    if (value === 'delivered' || value === 'sent') return 'Delivered'
    if (value === 'pending') return 'Pending'
    return value.charAt(0).toUpperCase() + value.slice(1)
  }

  useEffect(() => {
    fetchNotifications()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refresh, meta.page, meta.perPage])
  return (
    <div className='notification-main'>
      <div className='container-fluid'>
        <TableWrapper
          eventFilterHeader
          footerVariant='listing'
          totalLabel='Total Notifications'
          searchPlaceholder='Search...'
          setPerPage={handleSetPerPage}
          setSearchQuery={handleSetSearchQuery}
          searchValue={meta.search}
          totalListCount={meta.totalCount}
          pageSize={meta.perPage}
          currentPage={meta.page}
          onPageChange={handlePageChange}
          actionButtons={[
            {
              label: 'Add notification',
              ariaLabel: 'Add notification',
              icon: <img src={AddIcon} width={20} height={20} alt='' />,
              handleClick: handleOpenModal,
            },
          ]}
        >
          {loading ? (
            <p style={{ textAlign: 'center' }}>Loading</p>
          ) : (
            <table className='table notification-table'>
              <thead>
                <tr>
                  <th scope='col'>Notification Title</th>
                  <th scope='col'>Notification Body</th>
                  <th scope='col'>Scheduled Date/Time</th>
                  <th scope='col'>
                    <button
                      type='button'
                      className='notification-sort'
                      onClick={() =>
                        setStatusSort((current) =>
                          current === 'asc' ? 'desc' : 'asc'
                        )
                      }
                    >
                      Status
                      <img src={SortIcon} width={20} height={20} alt='' />
                    </button>
                  </th>
                  <th scope='col' className='notification-table__actions'>
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody>
                {visibleNotifications.map((item) => {
                  const itemId = item._id || item.id
                  const status = String(item.status || 'pending').toLowerCase()
                  return (
                    <tr key={itemId}>
                      <td>
                        <p className='notification-cell' title={item.title}>
                          {item.title || 'N/A'}
                        </p>
                      </td>
                      <td>
                        <p className='notification-cell' title={item.body}>
                          {item.body || 'N/A'}
                        </p>
                      </td>
                      <td>
                        <p className='notification-cell'>
                          {item.dateTime
                            ? moment(item.dateTime).format(
                                'MMM D, YYYY, hh:mm:ss a'
                              )
                            : 'N/A'}
                        </p>
                      </td>
                      <td>
                        <span
                          className={`notification-status notification-status--${status}`}
                        >
                          {statusLabel(item.status)}
                        </span>
                      </td>
                      <td className='notification-table__actions'>
                        <div className='notification-actions'>
                          <button
                            type='button'
                            className='notification-actions__button'
                            aria-label='Notification actions'
                            onClick={() =>
                              setOpenActionId((current) =>
                                current === itemId ? null : itemId
                              )
                            }
                          >
                            <img src={MoreIcon} width={20} height={20} alt='' />
                          </button>
                          {openActionId === itemId && (
                            <div className='notification-actions__menu'>
                              <button
                                type='button'
                                onClick={() => {
                                  setSelectedNotification(item)
                                  setOpenActionId(null)
                                  handleOpenModal()
                                }}
                              >
                                Edit
                              </button>
                              <button
                                type='button'
                                onClick={() => {
                                  setIsDeleting(true)
                                  setSelectedNotification(item)
                                  setOpenActionId(null)
                                  handleOpenNotificationConfirmationModal()
                                }}
                              >
                                Delete
                              </button>
                            </div>
                          )}
                        </div>
                      </td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
          )}
        </TableWrapper>
      </div>
      {isNotificationConfirmationModalVisible && (
        <ConfirmationModal
          handleConfirmNotification={
            isDeleting ? handleDeleteNotification : handleConfirmNotification
          }
          handleCloseModal={handleCloseNotificationConfirmationModal}
          isDeleting={isDeleting}
          selectedNotification={selectedNotification}
        />
      )}
      {isNotificationModalVisible && (
        <NotificationModal
          handleCloseModal={handleCloseModal}
          selectedNotification={selectedNotification}
          handleSaveNotification={handleCreateNotification}
          handleUpdateNotification={handleUpdateNotification}
        />
      )}
    </div>
  )
}

export default NotificationsListing
